module.exports = __webpack_public_path__ + "static/img/pictureD.3a85ebd4.png";